import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { ProductCard } from '../components/ProductCard'

export default function Matcha(){
  const { t } = useTranslation()

  const matchaProducts = [
    {
      name: t('matcha.products.premium.name'),
      description: t('matcha.products.premium.desc'),
      image: '/images/matcha-removebg-preview.png',
      sizes: [
        { size: '30G', price: t('pricing.demand') },
        { size: '50G', price: t('pricing.demand') }
      ]
    },
    {
      name: t('matcha.products.latte.name'),
      description: t('matcha.products.latte.desc'),
      image: '/images/matcha-removebg-preview.png',
      sizes: [
        { size: '30G', price: t('pricing.demand') },
        { size: '50G', price: t('pricing.demand') }
      ]
    },
    {
      name: t('matcha.products.osucha.name'),
      description: t('matcha.products.osucha.desc'),
      image: '/images/matcha-removebg-preview.png',
      sizes: [
        { size: '30G', price: t('pricing.demand') },
        { size: '50G', price: t('pricing.demand') }
      ]
    }
  ]

  return (
    <main>
      <Helmet><title>{t('matcha.title')}</title></Helmet>

      {/* HERO */}
      <section className="hero">
        <img src="/images/logo-removebg-preview (1).png" alt="Pearl of Galia logo" className="brand-logo-hero" />
        <div className="brand">
          <h1>
            <span>CEREMONIAL</span><br/>
            <span>MATCHA</span>
          </h1>
          <p className="tagline">AUTHENTIC JAPANESE TRADITION</p>
        </div>
      </section>

      {/* MATCHA INTRO */}
      <section className="room">
        <div className="grid">
          <div>
            <h2 className="section-title">PURE CEREMONIAL GRADE</h2>
            <p><strong>Stone-milled perfection from Uji's finest gardens.</strong></p>
            <p>Our ceremonial matcha comes from first-harvest tencha leaves, shade-grown for 3-4 weeks to develop deep umami and vibrant chlorophyll. Each batch is stone-ground in traditional granite mills to preserve the delicate cell structure and ensure the finest powder.</p>

            <p className="label">ORIGIN</p>
            <p>Uji region, Kyoto Prefecture, Japan</p>

            <p className="label">GRADE</p>
            <p>Ceremonial (Koicha & Usucha)</p>

            <p className="label">HARVEST</p>
            <p>First flush (Ichibancha) only</p>
          </div>
          <div>
            <img src="/images/matcha-removebg-preview.png" alt="Traditional matcha preparation" />
          </div>
        </div>
      </section>

      {/* E-COMMERCE SECTION */}
      <section className="room">
        <h2 className="section-title">OUR MATCHA COLLECTION</h2>
        <div className="product-grid">
          {matchaProducts.map((product, index) => (
            <ProductCard
              key={index}
              name={product.name}
              description={product.description}
              image={product.image}
              sizes={product.sizes}
            />
          ))}
        </div>
      </section>

      {/* PREPARATION GUIDE */}
      <section className="room">
        <div className="grid">
          <div>
            <img src="/images/tasting-removebg-preview.png" alt="Matcha preparation tools" />
          </div>
          <div>
            <h2 className="section-title">PREPARATION</h2>
            <p><strong>Traditional whisking for optimal results.</strong></p>

            <p className="label">TEMPERATURE</p>
            <p>70-80°C (158-176°F) water</p>

            <p className="label">RATIO</p>
            <p>2g matcha : 60ml water (usucha)<br/>
            4g matcha : 30ml water (koicha)</p>

            <p className="label">METHOD</p>
            <p>Sift matcha through fine mesh. Add small amount of water, whisk in 'W' motions until frothy. Gradually add remaining water while whisking.</p>

            <p className="label">STORAGE</p>
            <p>Refrigerate in airtight container. Consume within 6 months of opening.</p>
          </div>
        </div>
      </section>
    </main>
  )
}
